import React, { useEffect, useRef, useCallback, useMemo } from 'react';
import TreeView from 'devextreme-react/tree-view';
import { navigation } from '../../app-navigation';
import { useNavigation } from '../../contexts/navigation';
import { useScreenSize } from '../../utils/media-query';
import './SideNavigationMenu.scss';


import * as events from 'devextreme/events';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRightFromBracket, faGear, faUser } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router';
import { useAuth } from '../../contexts/auth';

export default function SideNavigationMenu(props) {
  const {
    children,
    selectedItemChanged,
    openMenu,
    compactMode,
    onMenuReady
  } = props;

  const navigate = useNavigate();
  const {signOut} = useAuth();



  const { isLarge } = useScreenSize();
  function normalizePath () {
    const userData = JSON.parse(localStorage.getItem("userData"))
    if (userData !== undefined && userData !== null){
      return userData.menu.map((item) => (
        { ...item, expanded: isLarge, path: item.path && !(/^\//.test(item.path)) ? `/${item.path}` : item.path }
      ))
    } else {
      return navigation.map((item) => (
        { ...item, expanded: isLarge, path: item.path && !(/^\//.test(item.path)) ? `/${item.path}` : item.path }
      ))
    }
  }

  const items = useMemo(
    normalizePath,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const { navigationData: { currentPath } } = useNavigation();

  const treeViewRef = useRef(null);
  const wrapperRef = useRef();
  const getWrapperRef = useCallback((element) => {
    const prevElement = wrapperRef.current;
    if (prevElement) {
      events.off(prevElement, 'dxclick');
    }

    wrapperRef.current = element;
    events.on(element, 'dxclick', (e) => {
      openMenu(e);
    });
  }, [openMenu]);

  useEffect(() => {
    const treeView = treeViewRef.current && treeViewRef.current.instance;
    if (!treeView) {
      return;
    }

    if (currentPath !== undefined) {
      treeView.selectItem(currentPath);
      treeView.expandItem(currentPath);
    }

    if (compactMode) {
      treeView.collapseAll();
    }
  }, [currentPath, compactMode]);

  return (
    <div
      className={'dx-swatch-additional side-navigation-menu'}
      ref={getWrapperRef}
    >
      {children}
      <div className={'menu-container'}>
        <TreeView
          className='treeView'
          ref={treeViewRef}
          items={items}
          keyExpr={'path'}
          selectionMode={'single'}
          focusStateEnabled={false}
          expandEvent={'click'}
          onItemClick={selectedItemChanged}
          onContentReady={onMenuReady}
          width={'100%'}
        />

        <div className='optionsMenuContainer'>
          <div className="optionsMenu" onClick={() => {navigate('/profile')}}>
            <FontAwesomeIcon icon={faUser} />
            <p>Perfil</p>
          </div>
          {/* <div className="optionsMenu">
            <FontAwesomeIcon icon={faGear} />
            <p>Configuración</p>
          </div> */}
          <div className="optionsMenu logOut" onClick={signOut}>
            <FontAwesomeIcon icon={faArrowRightFromBracket} />
            <p>Cerrar Sesión</p>
          </div>
          
          
        </div>
      </div>
      
    </div>
  );
}
